module.exports = __webpack_public_path__ + "static/media/IMG_4512 from entry.d7d70c8d.JPG";